/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { Modal } from 'semantic-ui-react'
// Local
import {
  User,
  EncounterConditionDisplay,
  EncounterConditionDisplayModified
} from '../../authenticated/types'
import If from '../../common/if'
import { condition as conditionUtils } from '../../common/conditionUtils'
import { encounterConditionDisplayNlpAnnotatedLinks } from '../../common/currentUserUtils'
import { isNLPDocument } from '../../v2/utils/utils'
import {
  filterPayloads,
  NLPPayload
} from '../../../json/nlpPayload'
import { API_URL } from '../../../constant'
import { api } from '../../../action/api'
import Close from '../../icons/close'
import Nlp from '../../common/nlp'

type Props = {
  condition: EncounterConditionDisplay | EncounterConditionDisplayModified
  currentUser: User
}

async function getNLPText(documentId: string): Promise<NLPPayload[]> {
  const nlpData = await api
    .get(API_URL.NLP_TEXT(documentId))
    .then(response => response.data)
  return nlpData
}

function NLPExtractedLink(props: Props): JSX.Element {
  const { condition, currentUser } = props

  const [ nlpData, setNlpData ] = useState<NLPPayload[]>([] as NLPPayload[])
  const [ isNLPModalShowing, setIsNLPModalShowing ] = useState<boolean>(false)

  const handleNLPClick = async (e: any, ecd: EncounterConditionDisplay | EncounterConditionDisplayModified) => {
    e.preventDefault()
    e.stopPropagation()
    const ruleId = (ecd && ecd.rules && ecd.rules[0].targetId) || ''
    const data = await getNLPText(ruleId)
    // Attempt filtering the nlp payloads
    const reducedPayloads = filterPayloads(data, ecd)
    // last minute fallback check
    setNlpData((reducedPayloads.length > 0) ? reducedPayloads : data)
    // setNlpData(nlpPayload)
    setIsNLPModalShowing(true)
  }

  return (
    <>
      <Modal
        className="nlp-modal"
        onClose={ () => setIsNLPModalShowing(false) }
        onOpen={ () => setIsNLPModalShowing(true) }
        open={ isNLPModalShowing }
        size="tiny"
        closeIcon={
          <div className="modal-close">
            <div className="close-icon">
              <Close />
            </div>
          </div>
        }
        closeOnDimmerClick={ false }
      // trigger={ <Button>Basic Modal</Button> }
      >
        <>
          <div className="nlp-modal-header">
            <span className="nlp-header-doc">Document Type:</span>{ ' ' }
            { nlpData.length && nlpData[0].documentTypeCode }
            <br />
            <span className="nlp-header-doc">
              Document Date of Service:{ ' ' }
            </span>{ ' ' }
            { nlpData.length && nlpData[0].documentDateOfService }
          </div>
          <Nlp payload={ nlpData } />
        </>
      </Modal>
      <If
        isTrue={
          conditionUtils.isPotential(condition) && isNLPDocument(condition) &&
          encounterConditionDisplayNlpAnnotatedLinks(currentUser)
        }
      >
        <p>
          <span>Click&nbsp;</span>
          <a href="#" onClick={ e => handleNLPClick(e, condition) }>
            here&nbsp;
          </a>
          <span>to view annotated text from original document.</span>
        </p>
      </If>
    </>
  )
}

export default NLPExtractedLink
